import { Button } from 'avo-ui'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import { ACTION_TYPE } from 'constants/constant'
import { Link } from 'react-router-dom'

export const TABLE_STORE = {
    name: 'Store',
    column: [
        {
            name: 'Nama Store',
            key: 'name',
            className: 'capitalize',
            width: 100,
        },
        {
            name: 'Kota',
            key: 'city',
            render: ({ value }) => <div>{value?.name}</div>,
        },
        {
            name: 'Alamat',
            key: 'address',
            className: 'whitespace-pre-line'
        },
        {
            name: 'Nomor Telpon',
            key: 'phone_number',
        },
        {
            name: 'Jam Operasional',
            key: 'time',
            width: 130,
            render: ({ item }) => (
                <div>
                    {item?.opening_time?.slice(0, 5)} - {item?.closing_time?.slice(0, 5)}
                </div>
            ),
        },
        {
            name: 'Link Maps',
            key: 'map_url',
            render: ({ value }) => (
                <Link to={value} target={'_blank'} className={'underline text-primary-100'}>
                    {value}
                </Link>
            ),
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button
                    type={'outline'}
                    title={'Edit'}
                    icon={icEditYellow}
                    onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
